import { render, staticRenderFns } from "./formBasic.vue?vue&type=template&id=a249790e"
import script from "./formBasic.vue?vue&type=script&lang=js"
export * from "./formBasic.vue?vue&type=script&lang=js"
import style0 from "./formBasic.vue?vue&type=style&index=0&id=a249790e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports